import AbstractPrintableHttpException from './AbstractPrintableHttpException';
import SQLErrorMessage from '../components/ErrorRepresentation/SQLErrorMessage';

type ParsedErrorDetails = {
    code: string,
    message: string,
    driver: {
        code: number,
        message: string,
    },
    sql: string,
};

export default class ServerSQLErrorHttpException extends AbstractPrintableHttpException {
    name = 'ServerSQLErrorHttpException';

    protected parsedDetails!: ParsedErrorDetails | null;

    constructor(response: Response, protected responseBody?: any) {
        super(response, responseBody?.message ?? 'Exceptions.services.http.server_error');

        this.parsedDetails = this.parseSQLErrorException();
        if (this.parsedDetails) {
            this.message = this.parsedDetails.message;
        }
    }

    getErrorDetails() {
        return this.parsedDetails;
    }

    getRepresentationTitle(): string {
        if (this.parsedDetails) {
            return 'SQL Error: ' + this.parsedDetails.message;
        }

        return super.getRepresentationTitle();
    }

    getMessageComponent() {
        return SQLErrorMessage;
    }

    getHtmlResponse(): null {
        return null;
    }

    private parseSQLErrorException(): ParsedErrorDetails | null {
        const regexp = /^SQLSTATE\[(?<code>.+)]: (?<message>[^:]+): (?<driverCode>\d+) (?<driverMessage>.+) \(Connection: (?<connection>.+), SQL: (?<sql>.+)\)/im;
        const matchResult = this.responseBody?.message?.match(regexp);
        if (!matchResult || !matchResult.groups) {
            return null;
        }

        const {driverCode, driverMessage, ...details} = matchResult.groups;

        return {
            ...details,
            driver: {
                code: driverCode,
                message: driverMessage,
            }
        };
    }
}
